import { ShomeiEntry } from "src/api";
export class ShomeiEntryViewModel {
    constructor(data) {
        this.model = data;
    }
    model = new ShomeiEntry();
}
